<template>
  <div>
    <alert
      :visible="!!alert_message"
      dark
      :type="type_alert"
      :message="alert_message"
      :clickClose="() => (alert_message = '')"
    />
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="shippings"
      :search="search"
      sort-by="provider"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>CONFIGURAÇÕES FRETE POR FORNECEDOR</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busca"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-toolbar color="red lighten-1" dark class="text-h5"
                >Atenção</v-toolbar
              >
              <v-card-title class="text-h6">
                Tem certeza que deseja Deletar?
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete()"
                  >Fechar</v-btn
                >
                <v-btn color="red darken-1" dark @click="deleteItemConfirm()">
                  <v-icon dark>mdi-delete</v-icon>
                  Deletar
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.status="{ item }">
        <v-chip label :color="getColor(item.status)" dark>
          {{ getLabel(item.status) }}
        </v-chip>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.provider="{ item }">
        {{ `${item.company.code} - ${item.company.name}` }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.type="{ item }">
        {{ getType(item) }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.minimum_order="{ item }">
        {{ getMinimumOrderFormat(item) }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.area="{ item }">
        <span v-for="line in getArea(item)" :key="line.id">
          <strong>{{ line.name }}</strong>
          <br />
        </span>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="blue darken-1">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="blue darken-1"
              @click="editItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as CompanyPromotionAPI from "@/api/requests/CompanyPromotionRequest";
import * as ShippingCompanyAPI from "@/api/requests/ShippingRequest";

import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      { text: "Fornecedor", value: "providerFull", width: 220 },
      { text: "Frete CIF?", value: "status", width: 80, align: "center" },
      { text: "Tipo", value: "type", width: 80 },
      {
        text: "Pedido Minimo",
        value: "minimum_order",
        width: 80,
        align: "center",
      },
      { text: "Área", value: "area", width: 120 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 80,
        align: "right",
      },
    ],
    shippings: [],
    editedItem: {
      id: "",
      name: "",
      status: 1,
    },
    defaultItem: {
      id: "",
      name: "",
      status: 1,
    },
    past_promotions: false,
    alert_message: "",
    type_alert: "",
  }),

  computed: {},

  watch: {},
  filters: {
    dateFormatBr: function (value) {
      return value.split("-").reverse().join("/");
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getShippings();
    },
    getColor(status) {
      return status ? "green" : "gray";
    },
    getLabel(status) {
      return status ? "Sim" : "Não";
    },
    getType(item) {
      if (item.type == "") return;
      return item.type == "pair" ? "Quantidade" : "Valor";
    },
    getArea(item) {
      if (!item.status) return;
      let area = [
        {
          id: 1,
          name: "BRASIL TODO",
        },
      ];
      if (item.regions.length > 0 && item.states.length > 0) {
        area = [
          {
            id: 1,
            name:
              item.regions.length > 1
                ? `EXCEÇÃO EM ${item.regions.length} REGIÕES`
                : "EXCEÇÃO EM 1 REGIÃO",
          },
          {
            id: 2,
            name:
              item.states.length > 1
                ? `EXCEÇÃO EM ${item.states.length} ESTADOS`
                : "EXCEÇÃO EM 1 ESTADO",
          },
        ];
      } else if (item.regions.length > 0) {
        area = [
          {
            id: 1,
            name:
              item.regions.length > 1
                ? `EXCEÇÃO EM ${item.regions.length} REGIÕES`
                : "EXCEÇÃO EM 1 REGIÃO",
          },
        ];
      } else if (item.states.length > 0) {
        area = [
          {
            id: 1,
            name:
              item.states.length > 1
                ? `EXCEÇÃO EM ${item.states.length} ESTADOS`
                : "EXCEÇÃO EM 1 ESTADO",
          },
        ];
      }
      return area;
    },
    getMinimumOrderFormat(item) {
      if (item.minimum_order == "") return;
      return this.formatMinimum(item.minimum_order, item.type);
    },
    formatMinimum(value, type) {
      return type == "pair" ? parseInt(value) : this.currencyEuaToBr(value);
    },
    currencyEuaToBr(value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },

    async getShippings() {
      this.loading = true;
      this.promotions = [];
      try {
        let providers = await CompanyAPI.getAll("?type=for");

        let res = await ShippingCompanyAPI.getAll();
        console.log(res);

        providers = providers.filter(
          (item) =>
            res.find((ship) => ship.company_id === item.id) === undefined
        );

        providers = providers.map((item) => ({
          company_id: item.id,
          type: "",
          company: item,
          minimum_order: "",
          regions: [],
          states: [],
          created_at: "",
          updated_at: "",
          status: false,
        }));

        res = res.map((item) => ({ ...item, status: true }));

        res = [...res, ...providers];
        res = res
          .sort((a, b) => (a.company.code > b.company.code ? -1 : 1))
          .map((item) => ({
            ...item,
            providerFull: `${item.company.code} - ${item.company.name}`,
          }));
        console.log(res);
        this.shippings = [...res];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.$router.push({
        name: "ShippingSettingsEdit",
        params: { id: item.company_id },
      });
    },
    deleteItem(item) {
      // alert("A Implementar");
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.closeDelete();
      try {
        await CompanyPromotionAPI.destroy(this.editedItem.id);
        this.alert_message = "Promoção deletada com sucesso";
        this.type_alert = "success";
        this.initialize();
      } catch (error) {
        this.alert_message = `Ocorreu um problema ao deletar esta Promoção: ${error.message}`;
        this.type_alert = "error";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
  },
};
</script>
